/*###########################################################################
// Scroll to
//#########################################################################*/

import { scrollTo } from "../utilities/_scrollTo"

const scrollToSection = {
	elements: {},

	init() {
		const self = this

		self.scrollToOnLoad()
		self.scrollToSection()
	},

	scrollToOnLoad() {
		const scrollEl = document.querySelector('[data-scroll-to-on-load="true"]');

		if (scrollEl !== null) {
			const headerHeight = document.querySelector('.header').offsetHeight;
			scrollTo(scrollEl, -headerHeight)
		}
	},

	scrollToSection() {
		const self = this

		self.elements.scrollToEls = document.querySelectorAll('[data-scroll-to]')

		// Loop through each element and add the event listener
		self.elements.scrollToEls.forEach(element => {
			element.addEventListener('click', function (e) {
				e.preventDefault()
				// Get the target section's ID from the data attribute
				const targetId = this.getAttribute('data-scroll-to');

				// Use querySelector to get a single element
				const targetSection = document.querySelector(`${targetId}`)
				const headerHeight = document.querySelector('.header').clientHeight

				scrollTo(targetSection, -headerHeight)
			});
		});
	}
}

window.addEventListener('load', function () {
	scrollToSection.init()
})
